import loadable from '@loadable/component';

export const OrgDashboardAdminsLinksPageLoadable = loadable(
  () => import('./OrgDashboardAdminsLinksPage'),
  {
    resolveComponent: (module) => module.OrgDashboardAdminsLinksPage,
  },
);
